import axiosInstance from "helpers/api";
import { useEffect, useState } from "react";

const useConnectedEmails = () => {
  const [connectedEmails, setConnectedEmails] = useState<any[]>([]);

  useEffect(() => {
    axiosInstance.get("/connected-emails").then((res) => {
      setConnectedEmails(res.data.data || []);
    });
  }, []);

  return connectedEmails;
};

export default useConnectedEmails;
